<template>
  <div class="focused-panel">
    <div class="d-flex polytron-toolbar">
      <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create polygon" :pressed.sync="addEnabled" variant="primary">
        <icon scale=".6" name="plus"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select polygon" :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>


      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled"
             variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled"
             variant="primary">
        <icon scale=".6" name="pencil-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete poly" :disabled="!wellFeatureSelected"
             variant="primary">
        <icon scale=".6" name="times"/>
      </b-btn>
    </div>

    <b-modal no-close-on-backdrop no-close-on-esc v-model="showForm" :title="formTitle" @ok="onOK" @cancel="onCancel">
      <div slot="modal-header">
        <label>{{formTitle}}</label>
      </div>
      <div class="p-2">
        <b-form>
          <b-form-group label="CWP Name:" >
            <b-form-input id="wellIdent"
                          v-model="wellAttrs['cwpname']"
                          required
                          placeholder="Enter name"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Desc:" >
            <b-form-input v-model="wellAttrs['desc']" />
          </b-form-group>

          <b-form-group label="Sequence:" >
            <b-form-input v-model="wellAttrs['sequence']" />
          </b-form-group>

          <b-form-group label="Batch:" >
            <b-form-input v-model="wellAttrs['batch']" />
          </b-form-group>
        </b-form>
      </div>
    </b-modal>

  </div>
</template>

<script>
  import 'vue-awesome/icons/arrows-alt'
  import 'vue-awesome/icons/times'
  import 'vue-awesome/icons/plus'
  import 'vue-awesome/icons/save'
  import 'vue-awesome/icons/check'
  import Vue from 'vue'

  import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
  import uuidV1 from 'uuid/v1'

  export default {
    name: 'electric',
    components: {

    },
    mixins: [FeatureEditorMixin],
    data () {
      return {
        markLastModified: false,
        featureId: null,
        addPolyEnabled: false,
        addLineEnabled: false,
        addPointEnabled: false,
        identName: 'cwpname',
        wellAttrs: {
          cwpname: null,
          desc: '',
          batch: '',
          sequence: null
        },
        options: [],
        causes: [],
        wellLayerName: 'v4:management_poly_planning_cwp',
        geomType: 'Polygon',
        idName: 'gid',
      }
    },
    methods: {
      editProps (feature) {
        this.featureId = feature.get('id')
        FeatureEditorMixin.methods.editProps.call(this, feature)
      }
    },
    watch: {
      currentEditor (val) {
        if (val !== this.editorIdent) {
          this.addEnabled = false
          this.selectEnabled = false
          this.addLineEnabled = false
          this.addPointEnabled = false
          this.addPolyEnabled = false
        }
      },

      measureTool (val) {
        if (val) {
          this.addLineEnabled = false
          this.addPointEnabled = false
          this.addPolyEnabled = false
        }
      },
      infoTool (val) {
        if (val) {
          this.addLineEnabled = false
          this.addPointEnabled = false
          this.addPolyEnabled = false
        }
      },
      selectTool (val) {
        if (val) {
          this.addLineEnabled = false
          this.addPointEnabled = false
          this.addPolyEnabled = false
        }
      }
    },
    computed: {
      selectTool () {
        return this.selectEnabled
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/CWPEditor.vue